import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6933a11b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full flex items-center justify-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "shadow-xl drop-card" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["select relative h-full hover:text-primary font-bold dark:text-dark-text-dark", _ctx.windowWidth >= 1600 ? 'ml-4' : 'ml-4']),
    style: {"transition":"color 0.5s"},
    onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nested.hide.value = true)),
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nested.hide.value = false))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.titleImage != undefined)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            alt: "user icon",
            class: _normalizeClass(["border rounded-full object-cover", [_ctx.windowWidth >= 1600 ? 'image-style' : 'image-style-mini']]),
            src: _ctx.titleImage
          }, null, 10, _hoisted_2))
        : (_ctx.titleIcon != '')
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(["material-icons", [_ctx.windowWidth >= 1600 ? 'image-style' : 'image-style-mini']])
            }, _toDisplayString(_ctx.titleIcon), 3))
          : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["ml-2 whitespace-nowrap", _ctx.windowWidth >= 1600 ? 'text-lg' : 'text-base']),
        style: {"margin-top":"2px"}
      }, _toDisplayString(_ctx.titleText), 3),
      (_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass(["fill-current", _ctx.windowWidth >= 1600 ? 'w-6 h-6 ml-1' : 'w-4 h-4 ml-1']),
        style: {"float":"right","margin-top":"2px"},
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg"
      }, _hoisted_4, 2))
    ]),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuTextList, (menuText, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("button", {
                class: _normalizeClass(["drop-card-item border-r border-l", [
              {
                'list-round-first border-t': index === 0,
                'list-round-last border-b': index === _ctx.menuTextList.length - 1
              },
              `${_ctx.itemPY}`
            ]]),
                onClick: _ctx.menuClickList[index]
              }, [
                (_ctx.menuIconList.length > 0)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["material-icons mr-4 ml-2 my-auto", {
                'text-xl': _ctx.windowWidth >= 1600,
                'text-sm': _ctx.windowWidth < 1600
              }])
                    }, _toDisplayString(_ctx.menuIconList[index]), 3))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["text-sm my-auto", { 'ml-1': _ctx.menuIconList.length <= 0 }])
                }, _toDisplayString(menuText), 3)
              ], 10, _hoisted_6)
            ]))
          }), 128))
        ], 512), [
          [_vShow, !_ctx.nested.hide.value]
        ])
      ]),
      _: 1
    })
  ], 34))
}